// 同じキャンバスを開いている参加者の状態。
// PO Board の Viewer 構造に準拠。

export const VIEWER_DISPLAY_NAME_MAX_LENGTH = 160;
export const VIEWER_AVATAR_IMAGE_URL_MAX_LENGTH = 4 * 1024;

export interface Viewer {
  readonly userId: string;
  readonly displayName: string;
  readonly avatarImageUrl?: string | undefined;
  /** 名前未設定時のフォールバック表示色（ボーダーや背景に使用） */
  readonly color: string;
  /** 現在使用中のツール */
  readonly tool?: string | undefined;
  /** 現在選択中のキャンバスオブジェクト ID 一覧 */
  readonly selectedObjectIds?: readonly string[] | undefined;
  /** カーソル位置（正規化座標 0..1） */
  readonly cursor?: {
    readonly xRatio: number;
    readonly yRatio: number;
  } | undefined;
  /**
   * 現在の表示ビュー（pan / zoom）。フォーカスモードで他者の表示画面を追尾する用途に使う。
   * 高頻度更新になりやすいためサーバ側ではブロードキャストのみ行い、永続化は不要。
   */
  readonly view?: {
    readonly panX: number;
    readonly panY: number;
    readonly zoom: number;
  } | undefined;
}
